export const SPINNER_CONTAINER_MIN_HEIGHT = '9rem';
